/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menureadfullheading3Inputs */

const en_menureadfullheading3 = /** @type {(inputs: Menureadfullheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read a menu`)
};

const de_menureadfullheading3 = /** @type {(inputs: Menureadfullheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte einlesen`)
};

/**
* | output |
* | --- |
* | "Read a menu" |
*
* @param {Menureadfullheading3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadfullheading3 = /** @type {((inputs?: Menureadfullheading3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadfullheading3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadfullheading3(inputs)
	return de_menureadfullheading3(inputs)
});
export { menureadfullheading3 as "menuReadFullHeading" }